<template>
  <div class="thermal-trans-roof__table-wrap">
    <!-- header-row -->
    <div class="thermal-roof__table-header-row">
      <div class="table-headers" style="width: 12%">Orientation</div>
      <div class="table-headers" style="width: 15%">Component</div>
      <div class="table-headers" style="width: 10%"><span>Area</span><span style="font-size:12px">(m<sup>2</sup>)</span> <span>A</span></div>
      <div class="table-headers" style="width: 10%"><span>SHGC Equiv</span> <span>B</span></div>
      <div class="table-headers" style="width: 10%"><span>Orientation Factor</span> <span>C</span></div>
      <div class="table-headers" style="width: 15%">
        <span>Shading</span>
      </div>
      <div class="table-headers last-header" style="width: 10%">A*B*C</div>
    </div>
    <!-- data-rows -->

    <div v-for="(ventilator, j) in step3C.ventilatorArrObj" :key="ventilator.orient">
      <div class="data-row-wrap" v-if="ventilator.calcGlassArea !== 0">
        <div class="data-field" style="width: 12%">
          <div class="wall-direction">
            <span> {{ ventilator.orientation }}</span>
          </div>
        </div>

        <div class="data-field" style="width: 15%">
          {{ ventilator.selectedGlassMaterial.material || `----` }}
          <!-- <v-select :style="{ 'padding-top': '18px' }" dense outlined placeholder="Select" :items="components" /> -->
        </div>

        <div class="data-field" style="width: 10%">
          <div>{{ ventilator.calcGlassArea }}</div>
        </div>
        <!-- SHGC Equiv -->
        <div class="data-field" style="width: 10%">
          <div>{{ ventilator.shgcEff }}</div>
        </div>
        <div class="data-field" style="width: 10%">
          <!-- <div>{{ ventilator.orientFactor }}</div> -->
          <div>{{ orientFactor[ventilator.orientation][step1.latitude.value] }}</div>
        </div>
        <div class="data-field second-last-col" style="width: 15%">
          <v-select :style="{ 'padding-top': '18px' }" dense outlined placeholder="Select" v-model="ventilator.selectedShading" :items="shadings" item-text="title" item-value="id" return-object />
        </div>
        <div class="data-field last-col" style="width: 10%">
          <div>{{ ventilator.abcSHGCVentilator }}</div>
        </div>
      </div>
    </div>
    <hr />
  </div>
</template>

<script>
import LvInput from 'lightvue/input';
import { orientFactor } from '@/constant_data/orientationFactor';

export default {
  components: {
    LvInput,
  },
  data() {
    return {
      orientFactor,
      orientations: ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW'],

      components: [`Clear glass 5mm/VLT87`, `Clear glass 6mm/VLT86`, `Solar control glass, 6mm/VLT65`, `Clear glass 5mm/VLT85`, `DGU-6(Solar control)-12(air)-6(clear glass)/VLT59`, `DGU-6(Solar control)-12(air)-6(clear glass)/VLT18`, `DGU-6(Solar control)-12(air)-6(low-E glass)/VLT55`, `6mm ST 167 (Saint Gobain) Glass.`],
      shading: ['No shading', 'Horizontal 550mm overhang, h-1200mm', 'Balcony 1000mm overhang, h-2100mm', 'Vertical 600mm fin, Left, V-1500mm', 'Balcony 1200mm overhang, h-2100mm', 'Horizontal overhang 600mm, Vertical fins 600mm', 'Horizontal 550mm overhang, h-1900mm', '3-Side Covered Balcony 1100mm overhang-ECBC', 'Horizontal overhang 400mm, Vertical fins 400mm-ECBC', 'Horizontal overhang 470mm-ECBC', 'Horizontal 500mm overhang, h-1200mm', 'Horizontal 450mm overhang, h-1200mm'],
    };
  },
  computed: {
    schema: {
      get: function() {
        return this.$store.state.schema;
      },
      set: function(newSchema) {
        this.$store.dispatch('setSchema', newSchema);
      },
    },
    step1: {
      get: function() {
        return this.$store.state.schema.inputs.step1;
      },
      set: function(step1) {
        this.$store.dispatch('setStep1', step1);
      },
    },
    step3C: {
      get: function() {
        return this.$store.state.schema.inputs.step3C;
      },
      set: function(step3B) {
        this.$store.dispatch('setStep3C', step3C);
      },
    },
    retv6B: {
      get: function() {
        return this.$store.state.schema.inputs.retv6B;
      },
      set: function(retv6B) {
        this.$store.dispatch('setRetv6B', retv6B);
      },
    },
    retv6C: {
      get: function() {
        return this.$store.state.schema.inputs.retv6C;
      },
      set: function(retv6C) {
        this.$store.dispatch('setRetv6C', retv6C);
      },
    },
    shadings: {
      get: function() {
        return this.$store.state.shadings;
      },
      set: function(newShadings) {
        this.$store.dispatch('setShadings', newShadings);
      },
    },
  },
  beforeUpdate() {
    this.effectiveSHGC();
  },
  methods: {
    effectiveSHGC() {
      let totalABCVenti = 0;
      this.step3C.ventilatorArrObj.forEach(venti => {
        if (venti.calcGlassArea !== 0) {
          this.shadings.forEach(shading => {
            if (shading.id === venti.selectedShading.id) {
              venti.shgcEff = (shading.shgcEquiv[venti.orientation][this.schema.inputs.step1.latitude.value] * venti.selectedGlassMaterial.shgcUnshaded).toFixed(2);
              //abc calculation
              venti.abcSHGCVentilator = (venti.calcGlassArea * venti.shgcEff * this.orientFactor[venti.orientation][this.step1.latitude.value]).toFixed(2);
              //  total abc ventilator summation
              totalABCVenti = +totalABCVenti + +venti.abcSHGCVentilator;
            }
          });
        }
      });

      this.retv6C.total_abc_ventilator = +totalABCVenti.toFixed(2);
      console.log('Total abc ventilator', this.retv6C.total_abc_ventilator);
    },
  },
};
</script>

<style lang="scss" scoped>
.thermal-roof__table-header-row {
  display: flex;
  width: 100%;
  background-color: #dedede;
  justify-content: space-between;
  margin-top: 20px;

  .table-headers {
    color: #343f4b;

    padding: 10px;
    font-size: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    span {
      text-align: center;
    }
    // width: 33.33%;
    .last-header {
      margin-left: auto;
    }
  }
}

.step6A-fixed-rows {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  text-align: left;
  padding: 8px 0px;
}

.data-row-wrap {
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 8px 12px 4px 12px;
  // align-items: center;
  .data-field {
    width: 25%;
    flex-wrap: wrap;
    text-align: center;

    .wall-direction {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    // text-align: center;
  }
}
.second-last-col {
  // padding-left: 38px;
}
.last-col {
  // margin-right: 44px;
  padding-left: 20px;
  text-align: right;
}
.step6A__summary {
  margin-top: 10px;
  .summary-head {
    font-size: 18px;
    color: #343f4b;
    font-weight: 800;
    margin: 8px 0;
    .summary-block__wrap {
      display: flex;
      flex-direction: column;
      .summary-field__row {
        display: flex;
        justify-content: space-between;
      }
      .summary-field__label {
        font-size: 12px;
        color: #343f4b;
      }
    }
  }
}
.step6A-conclusion-wrap {
  padding: 8px;
  .step6A-conclusion-head {
    font-size: 18px;
    color: #343f4b;
    font-weight: 800;
    margin: 0px 0px 8px 0px;
  }
}
.step6A-wfrop-note {
  background-color: #e9f2fa;
  font-style: italic;
  padding: 8px;
  margin: 12px 0px;
}

.step6A-wfrop-conclusion {
  background-color: #b3f5db;
}
</style>
